// Start a Shopify store page (3 Nov 2026). <ec-launch>: assembles the storefront mock piece by piece ([data-s] = step),
// then shows the live and first-order toasts, rests, and replays while in view. <ec-steps>: lights the step in view and
// updates the sticky counter. <ec-countdown>: 5→1→Launch once when the band enters the viewport. Reduced motion = final state.
const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

class EcLaunch extends HTMLElement {
  connectedCallback() {
    this.items = [...this.querySelectorAll('[data-s]')];
    this.max = Math.max(...this.items.map((el) => +el.dataset.s));
    if (reduce) return this.show(this.max);
    this.io = new IntersectionObserver(([e]) => (e.isIntersecting ? this.play() : this.stop()), { threshold: 0.3 });
    this.io.observe(this);
  }
  disconnectedCallback() { this.io?.disconnect(); this.stop(); }
  show(step) { this.items.forEach((el) => el.toggleAttribute('data-on', +el.dataset.s <= step)); }
  play() {
    if (this.timer) return;
    let step = 0;
    this.show(0);
    this.timer = setInterval(() => {
      step += 1;
      if (step > this.max + 6) step = 0;
      this.show(Math.min(step, this.max));
    }, 650);
  }
  stop() { clearInterval(this.timer); this.timer = null; }
}

class EcSteps extends HTMLElement {
  connectedCallback() {
    this.steps = [...this.querySelectorAll('[data-step]')];
    this.num = this.querySelector('[data-step-num]');
    this.title = this.querySelector('[data-step-title]');
    this.fill = this.querySelector('[data-step-fill]');
    this.io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) this.set(this.steps.indexOf(e.target)); });
    }, { rootMargin: '-45% 0px -45% 0px' });
    this.steps.forEach((s) => this.io.observe(s));
    this.set(0);
  }
  disconnectedCallback() { this.io?.disconnect(); }
  set(i) {
    this.steps.forEach((s, j) => s.toggleAttribute('data-on', j === i));
    if (this.num) this.num.textContent = String(i + 1).padStart(2, '0');
    if (this.title) this.title.textContent = this.steps[i].dataset.title || '';
    if (this.fill) this.fill.style.scale = `${(i + 1) / this.steps.length} 1`;
  }
}

class EcCountdown extends HTMLElement {
  connectedCallback() {
    this.items = [...this.querySelectorAll('[data-c]')];
    if (reduce) return this.items.forEach((el) => el.setAttribute('data-on', ''));
    this.io = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      this.io.disconnect();
      this.items.forEach((el, i) => setTimeout(() => el.setAttribute('data-on', ''), 420 * i));
    }, { threshold: 0.5 });
    this.io.observe(this);
  }
  disconnectedCallback() { this.io?.disconnect(); }
}

if (!customElements.get('ec-launch')) customElements.define('ec-launch', EcLaunch);
if (!customElements.get('ec-steps')) customElements.define('ec-steps', EcSteps);
if (!customElements.get('ec-countdown')) customElements.define('ec-countdown', EcCountdown);
